import React from "react";

import { switchCompanyURL } from "Dashboard/EmployerUrls";
import { Helmet } from "react-helmet";
import companyToken from "Utils/companyToken";
import { routerUrlHelper } from "Utils/routerUrl";

import { NavItem } from "Cobalt/NavItem";
import Footer from "Common/Footer";
import { Col, Grid, Row } from "Common/Grid";
import { Div } from "Common/HTML";
import { usePartnerContext } from "Common/PartnerContext";
import ThemeInstaller from "Common/ThemeInstaller";
import { appendAuthParams } from "Common/TokenAuth/Utils";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

type Props = {
  title?: string;
  children?: React.ReactNode;
};

const NavBar = () => {
  const { partner } = usePartnerContext();
  const rightContent = [];
  if (companyToken()) {
    rightContent.push(
      <NavItem key="switchLink" eventKey="switchLink" href={appendAuthParams(routerUrlHelper(switchCompanyURL))}>
        Switch Company
      </NavItem>,
    );
  }
  return <ResponsiveTopBar branding={partner} collapseOnSelect={false} rightContent={rightContent} />;
};

const Chrome = ({ children, title }: Props) => {
  const { color } = usePartnerContext();
  return (
    <>
      <ThemeInstaller color={color} />
      <Helmet titleTemplate="SimplyInsured - %s" title={title} defaultTitle="SimplyInsured" />
      <Div className="flex flex-col min-h-screen bg-white">
        <NavBar />
        <Grid className="flex-grow">
          <Row>
            <Col>{children}</Col>
          </Row>
        </Grid>
        <Footer />
      </Div>
    </>
  );
};

export default Chrome;
